/* ==========================================================================
   Breeze Plus interactive manual
   Data-driven renderer (same engine as the Origin Smart Plus manual):
   loads the manual JSON, builds the install guides, troubleshooting, videos
   and customer email helper, and wires search, image zoom, progress tracking
   and analytics. Degrades gracefully if JS, the data file, or individual
   images are unavailable. Reuses the osp-* classes so it shares
   origin-smart-plus-manual.css.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-osp-manual]');
  if (!root) return;

  /* ---------- analytics helper (also exposed globally) ---------- */
  window.blusafeManualEvent = window.blusafeManualEvent || function (name, params) {
    params = params || {};
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, params));
    if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
      try { window.Shopify.analytics.publish(name, params); } catch (e) {}
    }
  };
  function track(name, params) { window.blusafeManualEvent(name, params || {}); }

  /* ---------- config from data attributes ---------- */
  var cfg = {
    dataUrl: root.getAttribute('data-osp-data-url') || '',
    imageBase: root.getAttribute('data-osp-image-base') || '',
    assetBase: root.getAttribute('data-osp-asset-base') || '',
    handle: root.getAttribute('data-osp-content-handle') || 'breeze-plus',
    pdf: root.getAttribute('data-osp-pdf') || '',
    contact: root.getAttribute('data-osp-contact') || '',
    android: root.getAttribute('data-osp-android') || '',
    ios: root.getAttribute('data-osp-ios') || ''
  };
  // Inline data (preview build) takes priority over a fetch.
  var inlineData = window.BREEZE_MANUAL_DATA || null;

  /* ---------- small helpers ---------- */
  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function slug(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }

  function resolveImg(src) {
    if (!src) return '';
    if (/^(https?:)?\/\//.test(src) || src.charAt(0) === '/') return src;
    if (src.indexOf('data:') === 0) return src;
    var base = cfg.imageBase || cfg.assetBase || '';
    if (base && base.charAt(base.length - 1) !== '/') base += '/';
    return base + src;
  }
  // High-resolution variant for the zoom view (e.g. foo.jpg -> foo_2x.jpg).
  function hiresVariant(url) {
    if (!url || url.indexOf('data:') === 0) return url;
    if (/_2x\.(jpe?g|png|webp)$/i.test(url)) return url;
    return url.replace(/\.(jpe?g|png|webp)$/i, '_2x.$1');
  }

  /* ---------- figure (image with zoom + graceful fallback) ---------- */
  function figure(img, opts) {
    opts = opts || {};
    var url = resolveImg(img.src);
    var fig = el('figure', 'osp-figure' + (opts.single ? ' osp-figure--single' : ''));
    var btn = el('button');
    btn.type = 'button';
    btn.className = 'osp-image-button';
    btn.setAttribute('data-osp-lightbox', hiresVariant(url));
    btn.setAttribute('data-osp-lightbox-fallback', url);
    btn.setAttribute('data-osp-caption', img.alt || '');
    btn.setAttribute('aria-label', 'Zoom image: ' + (img.alt || 'manual image'));
    var im = el('img');
    im.src = url;
    im.alt = img.alt || '';
    im.loading = 'lazy';
    im.decoding = 'async';
    im.addEventListener('error', function () { fig.classList.add('osp-figure--missing'); });
    if (im.complete && im.naturalWidth === 0) fig.classList.add('osp-figure--missing');
    btn.appendChild(im);
    var ph = el('span', 'osp-image-placeholder', esc(img.alt || 'Image unavailable'));
    btn.appendChild(ph);
    fig.appendChild(btn);
    if (opts.caption && img.alt) fig.appendChild(el('figcaption', null, esc(img.alt)));
    return fig;
  }

  function figureGrid(images, opts) {
    if (!images || !images.length) return null;
    var grid = el('div', 'osp-figures' + (images.length === 1 ? ' osp-figures--single' : ''));
    images.forEach(function (img) { grid.appendChild(figure(img, opts || {})); });
    return grid;
  }

  function calloutNode(type, title, content) {
    var c = el('div', 'osp-callout osp-callout--' + type);
    if (title) c.appendChild(el('strong', null, esc(title)));
    c.appendChild(el('div', null, '<p>' + esc(content) + '</p>'));
    return c;
  }

  function listBlock(label, items, ordered) {
    if (!items || !items.length) return null;
    var frag = document.createDocumentFragment();
    frag.appendChild(el('p', 'osp-subhead', esc(label)));
    var list = el(ordered ? 'ol' : 'ul', 'osp-list');
    items.forEach(function (it) { list.appendChild(el('li', null, esc(it))); });
    frag.appendChild(list);
    return frag;
  }

  var ANDROID_LOGO = '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true" focusable="false" style="display:block;flex:none;"><path d="M17.6 9.48l1.84-3.18c.16-.31.04-.69-.26-.85-.29-.15-.65-.06-.83.22l-1.88 3.24c-2.86-1.21-6.08-1.21-8.94 0L5.65 5.67c-.19-.29-.58-.38-.87-.2-.28.18-.37.54-.22.83L6.4 9.48C3.3 11.25 1.28 14.44 1 18h22c-.28-3.56-2.3-6.75-5.4-8.52zM7 15.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25zm10 0c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25z"/></svg>';
  var APPLE_LOGO = '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true" focusable="false" style="display:block;flex:none;"><path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.03 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701"/></svg>';

  function appLinksNode() {
    var wrap = el('div', 'osp-app-links');
    if (cfg.android) {
      var a = el('a', 'osp-button osp-button--primary', ANDROID_LOGO + ' Tuya Smart for Android');
      a.href = cfg.android; a.target = '_blank'; a.rel = 'noopener';
      a.setAttribute('data-osp-event', 'app_link_click'); a.setAttribute('data-app-store', 'google_play');
      wrap.appendChild(a);
    }
    if (cfg.ios) {
      var i = el('a', 'osp-button osp-button--secondary', APPLE_LOGO + ' Tuya Smart for iPhone');
      i.href = cfg.ios; i.target = '_blank'; i.rel = 'noopener';
      i.setAttribute('data-osp-event', 'app_link_click'); i.setAttribute('data-app-store', 'ios_app_store');
      wrap.appendChild(i);
    }
    return wrap;
  }

  /* ---------- progress persistence ---------- */
  var store = {
    key: 'osp-progress:' + cfg.handle,
    read: function () { try { return JSON.parse(localStorage.getItem(this.key)) || {}; } catch (e) { return {}; } },
    write: function (v) { try { localStorage.setItem(this.key, JSON.stringify(v)); } catch (e) {} }
  };
  var progress = store.read();
  var totalSteps = 0;
  var startedGuides = {};

  /* ---------- render guides ---------- */
  function renderGuides(guides) {
    var mount = $('[data-osp-guides]');
    if (!mount) return;
    mount.innerHTML = '';
    guides.forEach(function (g, gi) {
      totalSteps += (g.steps || []).length;
      var det = el('details', 'osp-guide');
      det.id = g.handle;
      if (g.priority) det.setAttribute('data-priority', g.priority);

      var sum = el('summary', 'osp-guide__summary');
      sum.appendChild(el('span', 'osp-guide__num', String(gi + 1)));
      var head = el('div', 'osp-guide__head');
      head.appendChild(el('h3', null, esc(g.title)));
      var meta = el('div', 'osp-guide__meta');
      if (g.category) meta.appendChild(el('span', 'osp-pill', esc(g.category)));
      if (g.estimated_time) meta.appendChild(el('span', 'osp-pill', esc(g.estimated_time)));
      if (g.difficulty) meta.appendChild(el('span', 'osp-pill', esc(g.difficulty)));
      var prog = el('span', 'osp-pill osp-guide__progress');
      meta.appendChild(prog);
      head.appendChild(meta);
      sum.appendChild(head);
      sum.appendChild(el('span', 'osp-guide__chevron', '⌄'));
      det.appendChild(sum);

      var body = el('div', 'osp-guide__body');
      if (g.summary) body.appendChild(el('p', 'osp-guide__summary-text', esc(g.summary)));

      // optional inline video (e.g. handing guide starts at the flip demo)
      if (g.video && g.video.youtube_id) {
        var vcard = el('div', 'osp-video');
        var vframe = el('div', 'osp-video__frame');
        var vifr = el('iframe');
        vifr.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(g.video.youtube_id) + (g.video.start ? '?start=' + encodeURIComponent(g.video.start) : '');
        vifr.title = g.video.title || g.title;
        vifr.loading = 'lazy';
        vifr.setAttribute('allow', 'accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
        vifr.setAttribute('allowfullscreen', '');
        vframe.appendChild(vifr);
        vcard.appendChild(vframe);
        if (g.video.caption) {
          var vbody = el('div', 'osp-video__body');
          vbody.appendChild(el('p', null, esc(g.video.caption)));
          vcard.appendChild(vbody);
        }
        body.appendChild(vcard);
      }

      var grid = figureGrid(g.images, { caption: true });
      if (grid) body.appendChild(grid);

      (g.warnings || []).forEach(function (w) { body.appendChild(calloutNode('warning', 'Warning', w)); });
      (g.tips || []).forEach(function (t) { body.appendChild(calloutNode('info', 'Tip', t)); });
      (g.notes || []).forEach(function (n) { body.appendChild(calloutNode('note', 'Note', n)); });

      if (g.app_links) body.appendChild(appLinksNode());

      // steps with checkboxes
      if (g.steps && g.steps.length) {
        body.appendChild(el('p', 'osp-subhead', 'Steps'));
        var ol = el('ol', 'osp-steps');
        g.steps.forEach(function (s, si) {
          var li = el('li');
          var id = g.handle + ':' + si;
          var cb = el('input');
          cb.type = 'checkbox'; cb.className = 'osp-step-check'; cb.id = 'cb-' + slug(id);
          cb.setAttribute('data-step-key', id);
          cb.setAttribute('aria-label', 'Mark step ' + (si + 1) + ' complete');
          if (progress[id]) { cb.checked = true; li.classList.add('is-done'); }
          var lab = el('label', 'osp-step-text', esc(s));
          lab.setAttribute('for', cb.id);
          li.appendChild(cb);
          li.appendChild(lab);
          ol.appendChild(li);
        });
        body.appendChild(ol);
      }

      if (g.expected_result) body.appendChild(calloutNode('success', 'Expected result', g.expected_result));
      var cm = listBlock('Common mistakes', g.common_mistakes);
      if (cm) body.appendChild(cm);

      body.appendChild(helpfulNode('guide', g.handle));
      det.appendChild(body);
      mount.appendChild(det);

      det.addEventListener('toggle', function () {
        if (det.open && !startedGuides[g.handle]) {
          startedGuides[g.handle] = true;
          track('guide_start', { content_handle: cfg.handle, guide: g.handle, guide_title: g.title });
        }
      });

      updateGuideProgress(det, g);
    });
  }

  function updateGuideProgress(det, g) {
    var steps = g.steps || [];
    if (!steps.length) { var p0 = $('.osp-guide__progress', det); if (p0) p0.style.display = 'none'; return; }
    var done = 0;
    steps.forEach(function (s, si) { if (progress[g.handle + ':' + si]) done++; });
    var pill = $('.osp-guide__progress', det);
    if (pill) {
      pill.textContent = done + '/' + steps.length;
      pill.classList.toggle('osp-pill--done', done === steps.length);
    }
  }

  /* ---------- render troubleshooting ---------- */
  function renderIssues(issues) {
    var mount = $('[data-osp-issues]');
    if (!mount) return;
    mount.innerHTML = '';
    issues.forEach(function (t) {
      var det = el('details', 'osp-issue');
      det.id = t.handle;
      if (t.priority) det.setAttribute('data-priority', t.priority);
      var sum = el('summary', 'osp-issue__summary');
      var h = el('div');
      if (t.category) h.appendChild(el('span', 'osp-issue__cat', esc(t.category) + (t.priority === 'high' ? ' • common' : '')));
      h.appendChild(el('h3', null, esc(t.title)));
      sum.appendChild(h);
      sum.appendChild(el('span', 'osp-issue__chevron', '⌄'));
      det.appendChild(sum);

      var body = el('div', 'osp-issue__body');
      if (t.explanation) body.appendChild(calloutNode('info', 'Why this happens', t.explanation));
      var sym = listBlock('Symptoms', t.symptoms);
      if (sym) body.appendChild(sym);
      var qc = listBlock('Quick checks', t.quick_checks);
      if (qc) body.appendChild(qc);
      var lc = listBlock('Likely causes', t.likely_causes);
      if (lc) body.appendChild(lc);
      var fx = listBlock('Fix steps', t.fix_steps, true);
      if (fx) body.appendChild(fx);
      if (t.app_links) body.appendChild(appLinksNode());

      if (t.related_guides && t.related_guides.length) {
        body.appendChild(el('p', 'osp-subhead', 'Related guides'));
        var rel = el('div', 'osp-related');
        t.related_guides.forEach(function (rg) {
          var a = el('a', null, '→ ' + esc(guideTitle(rg)));
          a.href = '#' + rg;
          a.setAttribute('data-osp-jump', rg);
          rel.appendChild(a);
        });
        body.appendChild(rel);
      }

      var ev = listBlock('Send this to support', t.support_evidence);
      if (ev) body.appendChild(ev);

      body.appendChild(helpfulNode('troubleshooting', t.handle));
      det.appendChild(body);
      mount.appendChild(det);

      var viewed = false;
      det.addEventListener('toggle', function () {
        if (det.open && !viewed) {
          viewed = true;
          track('troubleshooting_view', { content_handle: cfg.handle, issue: t.handle, issue_title: t.title });
        }
      });
    });
  }

  var GUIDE_TITLES = {};
  function guideTitle(handle) { return GUIDE_TITLES[handle] || handle; }

  /* ---------- videos ---------- */
  function videoCard(v, feature) {
    var card = el('div', 'osp-video' + (feature ? ' osp-video--feature' : ''));
    var frame = el('div', 'osp-video__frame');
    var ifr = el('iframe');
    ifr.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(v.youtube_id);
    ifr.title = v.title || 'Video';
    ifr.loading = 'lazy';
    ifr.setAttribute('allow', 'accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
    ifr.setAttribute('allowfullscreen', '');
    frame.appendChild(ifr);
    card.appendChild(frame);
    var b = el('div', 'osp-video__body');
    b.appendChild(el('h3', null, esc(v.title)));
    if (v.description) b.appendChild(el('p', null, esc(v.description)));
    card.appendChild(b);
    return card;
  }
  // Featured "Video guide" at the top of the page (first/primary video).
  function renderFeaturedVideo(videos) {
    var mount = $('[data-osp-featured-video]');
    if (!mount) return false;
    if (!videos || !videos.length) { var sec = mount.closest('.osp-section'); if (sec) sec.style.display = 'none'; return false; }
    mount.innerHTML = '';
    mount.appendChild(videoCard(videos[0], true));
    return true;
  }
  function renderVideos(videos) {
    var mount = $('[data-osp-videos]');
    if (!mount) return;
    var hasFeatured = !!$('[data-osp-featured-video]');
    var list = (videos || []).slice(hasFeatured ? 1 : 0);
    if (!list.length) { var sec = mount.closest('.osp-section'); if (sec) sec.style.display = 'none'; return; }
    mount.innerHTML = '';
    list.forEach(function (v) { mount.appendChild(videoCard(v, false)); });
  }

  /* ---------- support templates ---------- */
  function renderTemplates(templates) {
    var mount = $('[data-osp-templates]');
    if (!mount) return;
    if (!templates || !templates.length) { var sec = mount.closest('.osp-section'); if (sec) sec.style.display = 'none'; return; }
    mount.innerHTML = '';
    templates.forEach(function (tpl) {
      var det = el('details', 'osp-template');
      var sum = el('summary');
      sum.appendChild(el('span', null, esc(tpl.title)));
      sum.appendChild(el('span', 'osp-issue__chevron', '⌄'));
      det.appendChild(sum);
      var body = el('div', 'osp-template__body');
      var addr = cfg.contact || (inlineData && inlineData.support_email) || '';
      body.appendChild(el('p', 'osp-template__subject', 'To: ' + esc(addr) + (tpl.subject ? '<br>Subject: ' + esc(tpl.subject) : '')));
      var pre = el('pre');
      pre.textContent = tpl.body || '';
      body.appendChild(pre);
      var actions = el('div', 'osp-actions');
      if (addr) {
        var mail = el('a', 'osp-button osp-button--primary', 'Open in your email app');
        mail.href = 'mailto:' + addr + '?subject=' + encodeURIComponent(tpl.subject || '') + '&body=' + encodeURIComponent(tpl.body || '');
        mail.setAttribute('data-osp-event', 'support_email_open');
        actions.appendChild(mail);
      }
      var copy = el('button', 'osp-button osp-button--secondary osp-copy', 'Copy email text');
      copy.type = 'button';
      copy.setAttribute('data-osp-copy', '');
      actions.appendChild(copy);
      body.appendChild(actions);
      det.appendChild(body);
      mount.appendChild(det);
    });
  }

  /* ---------- table of contents + scrollspy ---------- */
  function renderToc(data) {
    var mount = $('[data-osp-toc]');
    if (!mount) return;
    var html = '<h2>On this page</h2><ul class="osp-toc__list">';
    html += '<li class="osp-toc__group">Install &amp; setup</li>';
    data.guides.forEach(function (g) {
      html += '<li><a class="osp-toc__link" href="#' + esc(g.handle) + '" data-osp-jump="' + esc(g.handle) + '">' + esc(g.title) + '</a></li>';
    });
    html += '<li class="osp-toc__group">Troubleshooting</li>';
    data.troubleshooting.forEach(function (t) {
      html += '<li><a class="osp-toc__link" href="#' + esc(t.handle) + '" data-osp-jump="' + esc(t.handle) + '">' + esc(t.title) + '</a></li>';
    });
    html += '</ul>';
    mount.innerHTML = html;
  }

  function setupScrollSpy() {
    var links = [].slice.call(root.querySelectorAll('.osp-toc__link'));
    if (!links.length || !('IntersectionObserver' in window)) return;
    var map = {};
    links.forEach(function (l) { map[l.getAttribute('data-osp-jump')] = l; });
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          links.forEach(function (l) { l.classList.remove('is-active'); });
          var active = map[e.target.id];
          if (active) active.classList.add('is-active');
        }
      });
    }, { rootMargin: '-20% 0px -70% 0px' });
    Object.keys(map).forEach(function (id) { var n = document.getElementById(id); if (n) obs.observe(n); });
  }

  /* ---------- progress bar ---------- */
  function renderProgressBar() {
    var mount = $('[data-osp-progress]');
    if (!mount) return;
    mount.innerHTML =
      '<div class="osp-progress__label"><span data-osp-progress-text>Installation progress</span>' +
      '<button type="button" class="osp-progress__reset" data-osp-progress-reset>Reset</button></div>' +
      '<div class="osp-progressbar"><span data-osp-progress-fill></span></div>';
    updateProgressBar();
  }
  function countDone() { var n = 0; Object.keys(progress).forEach(function (k) { if (progress[k]) n++; }); return n; }
  function updateProgressBar() {
    var fill = $('[data-osp-progress-fill]'); var txt = $('[data-osp-progress-text]');
    if (!fill) return;
    var done = countDone();
    var pct = totalSteps ? Math.round((done / totalSteps) * 100) : 0;
    fill.style.width = pct + '%';
    if (txt) txt.textContent = 'Installation progress — ' + done + ' of ' + totalSteps + ' steps (' + pct + '%)';
  }

  /* ---------- helpful widget ---------- */
  function helpfulNode(type, handle) {
    var w = el('div', 'osp-helpful');
    w.setAttribute('data-osp-helpful', type + ':' + handle);
    w.innerHTML =
      '<span>Was this helpful?</span>' +
      '<button type="button" data-helpful="yes">Yes</button>' +
      '<button type="button" data-helpful="no">No</button>' +
      '<span class="osp-helpful__thanks">Thanks for the feedback.</span>';
    return w;
  }

  /* ---------- search ---------- */
  function setupSearch(index) {
    var input = $('[data-osp-search]');
    var out = $('[data-osp-search-results]');
    if (!input || !out) return;
    var debounce;

    // Everyday words customers type, mapped onto the manual's vocabulary.
    var SYNONYMS = {
      wont: 'not', dont: 'not', doesnt: 'not', cant: 'not', isnt: 'not', broken: 'not',
      code: 'passcode', codes: 'passcodes', pin: 'passcode', password: 'passcode', number: 'passcode',
      fob: 'card', fobs: 'cards', tag: 'card', swipe: 'card', rfid: 'card',
      wifi: 'gateway', bridge: 'gateway', hub: 'gateway', internet: 'gateway', online: 'gateway', offline: 'gateway',
      wood: 'timber', wooden: 'timber',
      finger: 'fingerprint', thumb: 'fingerprint', thumbprint: 'fingerprint', biometric: 'fingerprint', print: 'fingerprint',
      jammed: 'sticking', stiff: 'sticking', loose: 'sticking',
      restart: 'reset', reboot: 'reset', initialise: 'reset', initialize: 'reset', initialization: 'reset', wipe: 'reset',
      connect: 'pair', connecting: 'pairing', sync: 'pair',
      fit: 'install', fitting: 'install', fitted: 'install', mount: 'install',
      dead: 'battery', flat: 'battery', power: 'battery', unresponsive: 'waking',
      bolt: 'deadbolt', bolts: 'deadbolt', hook: 'hooks', open: 'unlock', opening: 'unlock'
    };

    function norm(s) {
      return String(s || '').toLowerCase()
        .replace(/[\u2019\u2018]/g, "'").replace(/'/g, '')
        .replace(/[\-_\/*#]+/g, ' ')
        .replace(/[^a-z0-9 ]+/g, ' ')
        .replace(/\s+/g, ' ').trim();
    }
    var STOP = { the: 1, my: 1, is: 1, it: 1, to: 1, a: 1, an: 1, of: 1, on: 1, in: 1, and: 1, i: 1, me: 1, with: 1, for: 1 };
    function variants(t) {
      var v = [t];
      if (t.length > 3 && t.charAt(t.length - 1) === 's') v.push(t.slice(0, -1));
      if (SYNONYMS[t]) v.push(SYNONYMS[t]);
      return v;
    }
    var rows = index.map(function (r) {
      return { row: r, title: norm(r.title), summary: norm(r.summary || ''), rest: norm((r.keywords || '') + ' ' + (r.category || '')) };
    });
    // Score a row: title hits beat summary hits beat keyword hits.
    function scoreRow(r, terms, requireAll) {
      var score = 0, hits = 0;
      terms.forEach(function (t) {
        var vs = variants(t), best = 0;
        for (var i = 0; i < vs.length; i++) {
          var v = vs[i];
          if (!v || v.length < 2) continue;
          if (r.title.indexOf(v) !== -1) best = Math.max(best, 5);
          else if (r.summary.indexOf(v) !== -1) best = Math.max(best, 3);
          else if (r.rest.indexOf(v) !== -1) best = Math.max(best, 1);
        }
        if (best) hits++;
        score += best;
      });
      if (requireAll && hits < terms.length) return -1;
      if (!hits) return -1;
      if (r.row.type === 'troubleshooting') score += 0.5; // people usually search when stuck
      return score;
    }
    function runSearch(q) {
      var terms = norm(q).split(' ').filter(function (t) { return t.length >= 2 && !STOP[t]; });
      if (!terms.length) return { matches: [], terms: terms, fuzzy: false };
      var strict = [], loose = [];
      rows.forEach(function (r) {
        var s = scoreRow(r, terms, true);
        if (s >= 0) { strict.push([s, r.row]); return; }
        s = scoreRow(r, terms, false);
        if (s >= 0) loose.push([s, r.row]);
      });
      if (!strict.length && !loose.length) {
        // typo fallback: retry with just the first few letters of each longer word
        var stems = terms.map(function (t) { return t.length >= 5 ? t.slice(0, 4) : t; });
        rows.forEach(function (r) {
          var s = scoreRow(r, stems, false);
          if (s >= 0) loose.push([s, r.row]);
        });
      }
      var list = strict.length ? strict : loose;
      list.sort(function (a, b) { return b[0] - a[0]; });
      return { matches: list.slice(0, 10).map(function (x) { return x[1]; }), terms: terms, fuzzy: !strict.length && !!loose.length };
    }
    function render() {
      var q = input.value.trim();
      out.innerHTML = '';
      if (norm(q).length < 2) return;
      var res = runSearch(q);
      var matches = res.matches;

      clearTimeout(debounce);
      debounce = setTimeout(function () {
        track('manual_search', { content_handle: cfg.handle, search_query: q, result_count: matches.length });
        if (!matches.length) track('manual_search_no_results', { content_handle: cfg.handle, search_query: q });
      }, 600);

      if (!matches.length) {
        out.appendChild(el('div', 'osp-search-result',
          '<strong>No results found</strong><small>Try one of the popular searches above — or scroll to “Need more help?” below and email us, we\u2019re happy to help.</small>'));
        return;
      }
      if (res.fuzzy) out.appendChild(el('div', 'osp-search-result', '<small>Closest matches</small>'));
      matches.forEach(function (m) {
        var a = el('a', 'osp-search-result');
        a.href = '#' + m.anchor;
        a.setAttribute('data-osp-jump', m.anchor);
        a.setAttribute('data-osp-search-result', m.title);
        a.innerHTML = '<small>' + esc(m.type === 'troubleshooting' ? 'Fix a problem' : m.category) + '</small><strong>' +
          highlight(m.title, res.terms) + '</strong>' + (m.summary ? '<span>' + highlight(m.summary, res.terms) + '</span>' : '');
        out.appendChild(a);
      });
    }
    input.addEventListener('input', render);
    // Enter jumps straight to the best match.
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        var first = out.querySelector('a[data-osp-jump]');
        if (first) { e.preventDefault(); first.click(); }
      }
    });
    // Popular search chips fill the box.
    var chips = root.querySelectorAll('.osp-chip');
    for (var ci = 0; ci < chips.length; ci++) {
      chips[ci].addEventListener('click', function () {
        input.value = this.textContent;
        render();
        input.focus();
      });
    }
  }
  function highlight(text, terms) {
    var safe = esc(text);
    terms.forEach(function (t) {
      if (t.length < 2) return;
      var re = new RegExp('(' + t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
      safe = safe.replace(re, '<mark>$1</mark>');
    });
    return safe;
  }

  /* ---------- jump to + open target ---------- */
  function jumpTo(id) {
    var node = document.getElementById(id);
    if (!node) return;
    if (node.tagName === 'DETAILS') node.open = true;
    node.scrollIntoView({ behavior: 'smooth', block: 'start' });
    node.setAttribute('tabindex', '-1');
    try { node.focus({ preventScroll: true }); } catch (e) {}
  }

  /* ---------- lightbox ---------- */
  function openLightbox(src, caption, fallback) {
    if (!src) return;
    var lb = el('div', 'osp-lightbox');
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    var fig = el('figure');
    var img = el('img'); img.alt = caption || 'Manual image';
    if (fallback && fallback !== src) {
      img.addEventListener('error', function once() { img.removeEventListener('error', once); img.src = fallback; });
    }
    img.src = src;
    fig.appendChild(img);
    if (caption) fig.appendChild(el('figcaption', null, esc(caption)));
    var close = el('button', 'osp-lightbox__close', 'Close ✕'); close.type = 'button';
    lb.appendChild(close); lb.appendChild(fig);
    function done() { lb.remove(); document.removeEventListener('keydown', onKey); }
    function onKey(e) { if (e.key === 'Escape') done(); }
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target === close) done(); });
    document.addEventListener('keydown', onKey);
    document.body.appendChild(lb);
    close.focus();
  }

  /* ---------- delegated events ---------- */
  function wireEvents() {
    root.addEventListener('click', function (e) {
      var lb = e.target.closest('[data-osp-lightbox]');
      if (lb) { e.preventDefault(); openLightbox(lb.getAttribute('data-osp-lightbox'), lb.getAttribute('data-osp-caption'), lb.getAttribute('data-osp-lightbox-fallback')); return; }

      var jump = e.target.closest('[data-osp-jump]');
      if (jump) {
        e.preventDefault();
        var id = jump.getAttribute('data-osp-jump');
        if (jump.matches('[data-osp-search-result]')) track('manual_search_result_click', { content_handle: cfg.handle, title: jump.getAttribute('data-osp-search-result') });
        jumpTo(id);
        return;
      }

      var ev = e.target.closest('[data-osp-event]');
      if (ev) {
        var params = { content_handle: cfg.handle };
        if (ev.getAttribute('data-app-store')) params.app_store = ev.getAttribute('data-app-store');
        track(ev.getAttribute('data-osp-event'), params);
      }

      var copy = e.target.closest('[data-osp-copy]');
      if (copy) {
        var wrapEl = copy.closest('.osp-template__body') || copy.parentNode;
        var pre = wrapEl.querySelector('pre');
        if (pre) copyText(pre.textContent, copy);
        track('support_cta_click', { content_handle: cfg.handle, action: 'copy_template' });
      }

      var help = e.target.closest('[data-osp-helpful] [data-helpful]');
      if (help) {
        var widget = help.closest('[data-osp-helpful]');
        widget.setAttribute('data-answered', '');
        var ref = widget.getAttribute('data-osp-helpful').split(':');
        track('was_this_helpful', { content_handle: cfg.handle, section_type: ref[0], section: ref[1], helpful: help.getAttribute('data-helpful') });
      }
    });

    // step checkboxes -> progress
    root.addEventListener('change', function (e) {
      var cb = e.target.closest('.osp-step-check');
      if (!cb) return;
      var key = cb.getAttribute('data-step-key');
      progress[key] = cb.checked;
      store.write(progress);
      cb.closest('li').classList.toggle('is-done', cb.checked);
      var det = cb.closest('.osp-guide');
      var gHandle = key.split(':')[0];
      var g = GUIDE_BY_HANDLE[gHandle];
      if (det && g) updateGuideProgress(det, g);
      updateProgressBar();
      if (cb.checked) track('step_view', { content_handle: cfg.handle, guide: gHandle, step: Number(key.split(':')[1]) + 1 });
      if (g) {
        var allDone = (g.steps || []).every(function (s, si) { return progress[gHandle + ':' + si]; });
        if (allDone && g.steps && g.steps.length) track('guide_complete', { content_handle: cfg.handle, guide: gHandle, guide_title: g.title });
      }
    });

    var resetBtn = $('[data-osp-progress-reset]');
    if (resetBtn) resetBtn.addEventListener('click', function () {
      progress = {}; store.write(progress);
      root.querySelectorAll('.osp-step-check').forEach(function (cb) { cb.checked = false; cb.closest('li').classList.remove('is-done'); });
      root.querySelectorAll('.osp-guide').forEach(function (det) { var g = GUIDE_BY_HANDLE[det.id]; if (g) updateGuideProgress(det, g); });
      updateProgressBar();
    });
  }

  function copyText(text, btn) {
    function ok() { if (btn) { btn.setAttribute('data-copied', ''); setTimeout(function () { btn.removeAttribute('data-copied'); }, 2000); } }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(ok).catch(function () { legacy(); });
    } else { legacy(); }
    function legacy() {
      var ta = document.createElement('textarea'); ta.value = text; ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); ok(); } catch (e) {}
      ta.remove();
    }
  }

  /* ---------- back to top ---------- */
  function setupBackToTop() {
    var btn = $('[data-osp-totop]');
    if (!btn) return;
    window.addEventListener('scroll', function () {
      btn.classList.toggle('is-visible', window.scrollY > 700);
    }, { passive: true });
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ---------- boot ---------- */
  var GUIDE_BY_HANDLE = {};

  function build(data) {
    if (!data) return;
    (data.guides || []).forEach(function (g) { GUIDE_TITLES[g.handle] = g.title; GUIDE_BY_HANDLE[g.handle] = g; });
    renderToc(data);
    renderGuides(data.guides || []);
    renderIssues(data.troubleshooting || []);
    renderFeaturedVideo(data.videos || []);
    renderVideos(data.videos || []);
    renderTemplates(data.support_templates || []);
    renderProgressBar();
    setupSearch(data.search_index || buildIndex(data));
    wireEvents();
    setupScrollSpy();
    setupBackToTop();

    track('manual_view', { content_type: 'manual', content_handle: cfg.handle, product_family: 'Breeze Plus' });

    // open a deep-linked section
    if (location.hash) { var id = location.hash.slice(1); setTimeout(function () { jumpTo(id); }, 200); }
  }

  function buildIndex(data) {
    var idx = [];
    (data.guides || []).forEach(function (g) {
      idx.push({ title: g.title, type: 'guide', category: g.category, anchor: g.handle, summary: g.summary || '', keywords: (g.steps || []).join(' ') });
    });
    (data.troubleshooting || []).forEach(function (t) {
      idx.push({ title: t.title, type: 'troubleshooting', category: t.category, anchor: t.handle, summary: (t.symptoms || [''])[0], keywords: (t.fix_steps || []).join(' ') });
    });
    return idx;
  }

  function fail(msg) {
    var mount = $('[data-osp-guides]');
    if (mount) mount.innerHTML = '<div class="osp-callout osp-callout--warning"><strong>Manual content could not load.</strong><div><p>' +
      esc(msg) + ' Please use the PDF fallback at the top of the page.</p></div></div>';
  }

  if (inlineData) {
    build(inlineData);
  } else if (cfg.dataUrl) {
    fetch(cfg.dataUrl, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(build)
      .catch(function (err) { fail('Could not load the manual data file.'); });
  } else {
    fail('No data source configured.');
  }
})();
